import { CRUDProvider } from 'components/providers';
import { useTranslation } from 'react-i18next';
import { IndustryResources } from 'services/resources/preferences/industry';

import { Page } from './components/Page';

export const IndustryPage: React.FC = (): JSX.Element => {
  const { t } = useTranslation('industry');

  return (
    <CRUDProvider
      allowPost
      quote={t('page.quote')}
      resource={IndustryResources}
      title={t('page.title')}
    >
      <Page />
    </CRUDProvider>
  );
};
